import TodayIcon2 from "@mui/icons-material/Today";

import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { memo } from "react";

export function TodayIcon(props) {
  const txt = props.txt === undefined ? "TÄNÄÄN" : props.txt;
  const childProps = { ...props };
  delete childProps.withText;
  return (
    <div
      style={{
        position: "relative",
      }}>
      <Typography
        variant="caption"
        style={{ position: "absolute", top: 20, left: -10, opacity: 0.7 }}>
        {txt}
      </Typography>
      <div>
        <TodayIcon2 {...childProps} />
      </div>
    </div>
  );
}

TodayIcon.propTypes = {
  withText: PropTypes.bool,
  disabled: PropTypes.bool,
  txt: PropTypes.string,
};

export default memo(TodayIcon);
